// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"ModalUserInfo_iconContainer__ERmuK","modal":"ModalUserInfo_modal__D6FUQ"};